import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStylesSearch = makeStyles((theme: Theme) =>
  createStyles({
    textFieldWrapper: {
      width: '100%',
      borderRadius: 23,
      backgroundColor: '#e6e7e819',
    },
    textField: {
      width: '100%',
      color: '#ffffff',
      borderWidth: 1,
      borderColor: '#c0ccc1',
      '& .MuiOutlinedInput-adornedEnd': {
        color: '#ffffff',
        fontWeight: 500,
        fontSize: 17,
      },
      '& .MuiInputBase-root': {
        height: 45,
        color: '#ffffff',
        fontWeight: 500,
        fontSize: 17,
        padding: 0,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiAutocomplete-option': {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'red',
      },
    },
    search: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      padding: 0,
      cursor: 'pointer',
      marginRight: 7,
    },
    cancel: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      padding: 0,
      cursor: 'pointer',
      width: 12,
      height: 12,
    },
    select: {
      color: '#0c1514',
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: '17px !important',
    },
    selectName: {
      color: '#006997',
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: '17px !important',
    },
    selectType: {
      color: '#181c3280',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: 14,
    },
    selectBold: {
      color: '#0c1514',
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 17,
    },
    containerDivider: {
      padding: '0 17px',
    },
    divider: {
      height: 1,
      backgroundColor: 'red',
      width: '100%',
    },
    input: {
      height: 45,
      color: '#01402e',
      fontWeight: 500,
      fontSize: 17,
      padding: '0 10px',
    },
    adornment: {
      margin: 0,
    },
    containerType: {
      width: '40%',
      marginLeft: 8,
      textAlign: 'right',
    },
    title: {
      width: '55%',
      wordWrap: 'break-word',
      fontSize: '17px !important',
    },
    find: {
      color: '#6a96c3 !important',
      fontSize: '17px !important',
      fontWeight: 'normal !important',
    },
  })
);
